import {Component, computed, effect, inject, input, signal, ViewEncapsulation} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, FormGroupDirective} from "@angular/forms";
import {DiscountSelection, HarbourDuesIncidentalForm} from "../../../types";

import {toSignal} from "@angular/core/rxjs-interop";
import {HarbourDuesRotterdamResponse} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
  selector: 'app-reduction-rotterdam',
  templateUrl: './reduction-rotterdam.component.html',
  styleUrls: ['./reduction-rotterdam.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ReductionRotterdamComponent {
  readonly form = inject(FormGroupDirective);
  private readonly fb = inject(FormBuilder);

  readonly discountGroup = this.form.control.get('discount') as FormControl;
  readonly specialTariff = this.form.control.get('specialTariff') as FormControl;
  readonly exemption = this.form.control.get('exemption') as FormControl;
  readonly selectedType = this.form.control.get('selectedType') as FormControl;
  readonly harbourDuesDetails = input<HarbourDuesRotterdamResponse>();
  readonly isHarbourDuesAdvisor = input(false);

  readonly incidentals =
    this.form.control.get('incidentals') as FormArray<FormGroup<HarbourDuesIncidentalForm>>;
  readonly incidentalsValue = toSignal(
    this.incidentals.valueChanges,
    {initialValue: this.incidentals.getRawValue()}
  );
  readonly createInvoiceAdjustment = signal(false);
  readonly showIncidentals = computed(() =>
    this.incidentalsValue().length > 0
  );

  readonly selectedTypeValue = toSignal<DiscountSelection>(this.selectedType.valueChanges,
    {initialValue: this.selectedType.value});
  protected readonly DiscountSelection = DiscountSelection;

  constructor() {
    effect(() => this.toggleEnableDisable(this.selectedTypeValue()));
  }

  private toggleEnableDisable(value?: DiscountSelection) {
    switch (value) {
      case DiscountSelection.NO_DISCOUNT:
        this.exemption.disable();
         this.specialTariff.disable();
        this.discountGroup.disable();
        break;
      case DiscountSelection.DISCOUNT:
        this.discountGroup.enable();
        this.specialTariff.disable();
        this.exemption.disable();
        break;
      case DiscountSelection.EXEMPTION:
        this.discountGroup.disable();
        this.specialTariff.disable();
        this.exemption.enable();
        break;
      case DiscountSelection.SPECIAL_FEE:
        this.discountGroup.disable();
        this.exemption.disable();
        this.specialTariff.enable();
    }
  }

  formatSelectionType = (selectionType: DiscountSelection) => {
    switch (selectionType) {
      case DiscountSelection.EXEMPTION:
        return 'Exemption'
      case DiscountSelection.DISCOUNT:
        return 'Discount(s)';
      case DiscountSelection.SPECIAL_FEE:
        return 'Special tariff';
      default:
        return 'No discount';
    }
  }

  onClick() {
    if (this.incidentals.length === 0) {
      this.incidentals.push(this.createIncidentalForm());
    }
  }

  private createIncidentalForm(): FormGroup<HarbourDuesIncidentalForm> {
    return this.fb.group<HarbourDuesIncidentalForm>({
      incidentalType: this.fb.control(null),
      incidentalAmount: this.fb.control(null),
      incidentalReason: this.fb.control(null)
    });
  }
}
